import React from "react";

const Input = ({ label, name, className, Icon, lableClass, ...rest }) => {
  return (
    <div className="flex flex-col">
      {label && <label htmlFor={name} className={`mb-1 text-sm font-medium text-gray-400 ${lableClass}`}>
        {label}
      </label>}
      {Icon ? (
        <div
          className={`flex items-center border rounded-md border-gray-300 pr-1 bg-white ${className}`}
        >
         <div className="pl-4">
          {Icon}
         </div>
          <input
            id={name}
            name={name}
            className={`w-full p-3 pl-2 text-base text-black shadow-sm focus:outline-none focus:ring-0 disabled:opacity-50`}
            {...rest}
          />
        </div>
      ) : (
        <input
          id={name}
          name={name}
          className={`w-full rounded-md border border-gray-300 bg-white p-3 text-base text-black shadow-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 ${className}`}
          {...rest}
        />
      )}
    </div>
  );
};

export default Input;
